
import { getComputedCssValFloat, hasCssPropertyPrefixed, isElementScrollable } from '../dpitUtilsPublic';
import DpitTarget from './DpitTarget';
import { CLASSES_CORE, MODIFIERS } from './constants';



export default class DpitTargetParent extends DpitTarget {
	/**
	 * Initialize target object
	 *
	 * @param {Element} element
	*/
	constructor(element) {
		super(element);
		const computedStyle = getComputedStyle(element);
		const zIndex = computedStyle.getPropertyValue('z-index');
		const opacity = getComputedCssValFloat(element, 'opacity', 1, computedStyle);
		this.analysis = {
			...this.analysis,
			hasFilter: hasCssPropertyPrefixed(computedStyle, 'filter'),
			hasTransform: hasCssPropertyPrefixed(computedStyle, 'transform'),
			hasDecreasedOpacity: opacity < 1,
			hasZIndex: /[0-9]+/.test(zIndex),
			isScrollable: isElementScrollable(element, computedStyle)
		};
	}

	process(isZIdxFixParent) {
		this.element.classList.add(CLASSES_CORE.targetParent);
		this.needsZIndexFix = this.doesNeedZIndexFix(isZIdxFixParent, this.analysis);
		if (this.needsZIndexFix) {
			this.addClassSafe(CLASSES_CORE.targetParent + MODIFIERS.zIdxFix);
		}
	}

	doesNeedZIndexFix(isZIdxFixParent, analysis) {
		return isZIdxFixParent || analysis.hasTransform || analysis.hasFilter || analysis.hasDecreasedOpacity || analysis.hasZIndex || analysis.hasAltPosition;
	}

	destroy() {
		this.element.classList.remove(CLASSES_CORE.targetParent);
		this.removeClassSafe(CLASSES_CORE.targetParent + MODIFIERS.zIdxFix);
	}
}